const state = {
    filter: {},
    filters: [],
    pageSize: 25,
    currentPage: 1,
    pageStart: 1,
    pageEnd: 10,
    maxPage: 1,
    orderBy: "desc",
    context: "",
    pageBefore: "",
};

const mutations = {
    datatablecontent_currentPage: function (state, payload) {
        state.currentPage = payload;
    },

    datatablecontent_pageSize: function (state, payload) {
        state.pageSize = payload;
    },

    datatablecontent_maxPage: function (state, payload) {
        state.maxPage = payload;
    },

    datatablecontent_orderby: function (state, payload) {
        state.orderBy = payload;
    },

    datatablecontent_push_filter: function (state, payload) {
        state.filter = payload;
    },

    datatablecontent_push_filters: function (state, payload) {
        state.filters.push(payload);
    },

    datatablecontent_clear_filter: function (state) {
        state.filter = {};
        state.orderBy = "desc";
    },

    datatablecontent_clear_filters: function (state) {
        state.filters = [];
        state.orderBy = "desc";
    },

    datatablecontent_delete_one_filters: function (state, payload) {
        state.filters.splice(payload, 1);
        state.orderBy = "desc";
    },

    datatablecontent_context: function (state, payload) {
        state.context = payload;
    },

    datatablecontent_pageStart: function (state, payload) {
        state.pageStart = payload;
    },

    datatablecontent_pageEnd: function (state, payload) {
        state.pageEnd = payload;
    },

    datatablecontent_page_before: function (state, payload) {
        state.pageBefore = payload;
    },
};

export default {
    state,
    mutations,
};



// WEBPACK FOOTER //
// ./src/modules/global/stores/datatablecontent.js